<mat-card class="mat-elevation-z8">
    <form [formGroup]="location_category_register_form">
      <!-- user details -->
      <div class="form-group">
        <label>Location Category Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
        <input type="text" class="form-control" formControlName='location_category_name'>
      </div>
      <button style="margin-left: 40%;" mat-raised-button color="primary" [disabled]="!location_category_register_form.valid" (click)="registerLocationCategory()">{{action}}</button>
    </form>
  </mat-card>
  